﻿
import angular from 'angular';

import '../../../services/product';

angular.module('folkeuni').component('participantsList', {
  templateUrl: '/shop-dist/templates/participants-list.html',
  transclude: false,
  bindings:{
    siteId : '@'
  },
  controller: function(Product, $location) {
    var $ctrl = this;
    //  $ctrl.selectedLocation = !!$location.search().lId ? $location.search().lId : null;
    //      $ctrl.delveryDate = !!$location.search().attendancelistDate ? $location.search().attendancelistDate : null;

    $ctrl.locations = [{
        id: 639,
        label: "Aulaen, Aarhus Universitet",
      },
      {
        id: 2,
        label: "lokation 2",
      }
    ];

    $ctrl.events = [{
      Product: [{
        id: "1721-070",
        title: "Tre af Shakespeares bedste",
        place: "AU, Campus Emdrup, bygning D",
        date: "18.07.2017",
        time: "10-15.30"
      }],
      Employees: [{
          id: 1,
          orderNo: 12353,
          name: "Rasmus Sørensen",
          phone: "60515260",
          email: "ras@jcd.dk"
        },
        {
          id: 2,
          orderNo: 134123,
          name: "Jens Jensen",
          phone: "50515260",
          email: "jens@jcd.dk"
        }
      ],
      Attendees: [{
          id: 1,
          orderNo: 123,
          name: "Student 1",
          phone: "11111111",
          email: "student1@jcd.dk",
          Options: [{
            id: 1,
            accessories: "T-shirt"
          }]
        },
        {
          id: 2,
          orderNo: 3421,
          name: "Student 2",
          phone: "22222222",
          email: "student2@jcd.dk",
          Options: [{
            id: 2,
            accessories: "Bog"
          }]
        }
      ]
    }];

    // Sort columns 
    $ctrl.sortBy = function(propertyName) {
      $ctrl.reverse = ($ctrl.propertyName === propertyName) ? !$ctrl.reverse : false;
      $ctrl.propertyName = propertyName;

    };

    // Search participants events
    $ctrl.searchEvents = function() {



      var dateLocationObj = {
        date: new Date($ctrl.dateSelected.split('-').reverse().join('-')),
        locationId: $ctrl.locationSelected
      }

    //  console.log("Hvad er det vi sender afsted?",dateLocationObj);

      Product.attendeesGet(dateLocationObj).then(function(attendeesObj) {
         $ctrl.events =  attendeesObj.events;

      }, function(errorResponse) {
        console.log("error", errorResponse);
      })


      $ctrl.showEvents = true;
    }

    $ctrl.$onInit = function(){

$ctrl.eventShow = function(event){
  event.show = !event.show;
}
    Product.locationsGetBySiteId($ctrl.siteId).then(function(locationsObj) {
      $ctrl.locations = locationsObj;

      $ctrl.locationSelected = $ctrl.locations[0].id;
    }, function(errorResponse) {
      console.log("error", errorResponse);
    })

    }
  }
});
